import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, TextField, Select, MenuItem, InputLabel, FormControl } from '@material-ui/core';
import Http from '../../../Http';

const CodigoPostal = () => {
  const history = useHistory();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    codigo_postal: '',
    id_estado: '',
    id_ciudad: ''
  });

  const [options, setOptions] = useState({
    estados: [],
    ciudades: []
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadInitialData();
  }, [id]);

  const loadInitialData = async () => {
    setLoading(true);
    let currentData = { ...formData };
    
    // Si estamos editando, cargar data de DB
    if (id) {
      const res = await Http.post('codigo-postal/one', { id });
      if (!res.error && res.data) {
        currentData = { ...currentData, ...res.data };
        setFormData(currentData);
      }
    } else {
      // Si es nuevo, inicializar los catálogos vacíos primero
      await fetchGenerales();
    }
    
    // Cargar options basados en Estado (CP no carga ciudades en este contexto para no ciclar, solo estado lo hace)
    if (currentData.id_estado) {
        await fetchGenerales(null, currentData.id_estado);
    }
    setLoading(false);
  };

  const fetchGenerales = async (cp, estadoId) => {
    let url = `cliente/form-generales?`;
    if (estadoId) url += `e=${estadoId}&`;
    if (cp && cp.toString().length === 5) url += `cp=${cp}&`;

    const res = await Http.get(url);
    if (!res.error && res.data) {
      const newOptions = {
        estados: res.data.estados || options.estados,
        ciudades: res.data.ciudades || options.ciudades
      };
      
      setOptions(prevOptions => ({
         estados: newOptions.estados.length ? newOptions.estados : prevOptions.estados,
         ciudades: newOptions.ciudades.length ? newOptions.ciudades : prevOptions.ciudades,
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    // Update cities when state changes
    if (name === 'id_estado') {
      fetchGenerales(null, value);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await Http.post('codigo-postal/save', formData);
    setLoading(false);
    if (!res.error) {
      history.push('/Catalogo/CodigosPostales');
    } else {
      alert(res.message || 'Error al guardar');
    }
  };

  return (
    <div className="w-full p-4 md:p-6 bg-gray-50 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900 tracking-tight">
          {id ? 'Editar Código Postal' : 'Nuevo Código Postal'}
        </h1>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => history.push('/Catalogo/CodigosPostales')}
        >
          Regresar
        </Button>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6 max-w-3xl mx-auto">
        {loading && !id ? (
          <div className="text-center py-4">Cargando...</div>
        ) : (
          <form onSubmit={handleSave} className="space-y-6">
            
            <TextField
              fullWidth
              label="Código Postal"
              name="codigo_postal"
              value={formData.codigo_postal || ''}
              onChange={handleChange}
              required
              variant="outlined"
              inputProps={{ maxLength: 5 }}
            />

            <FormControl fullWidth variant="outlined" required>
              <InputLabel id="estado-label">Estado</InputLabel>
              <Select
                labelId="estado-label"
                name="id_estado"
                value={formData.id_estado || ''}
                onChange={handleChange}
                label="Estado"
              >
                <MenuItem value=""><em>Seleccione un Estado</em></MenuItem>
                {options.estados.map(est => (
                  <MenuItem key={est.id} value={est.id}>{est.estado}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth variant="outlined" required>
              <InputLabel id="ciudad-label">Ciudad</InputLabel>
              <Select
                labelId="ciudad-label"
                name="id_ciudad"
                value={formData.id_ciudad || ''}
                onChange={handleChange}
                label="Ciudad"
              >
                <MenuItem value=""><em>Seleccione una Ciudad</em></MenuItem>
                {options.ciudades.map(ciu => (
                  <MenuItem key={ciu.id} value={ciu.id}>{ciu.ciudad}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <div className="pt-4 flex justify-end">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded shadow-md"
              >
                Guardar Código Postal
              </Button>
            </div>
            
          </form>
        )}
      </div>
    </div>
  );
};

export default CodigoPostal;
